import { TOKEN_DECIMAL_PLACES } from '@did/constants'
import { useConfigVal, useDasBalanceContext } from '@did/das-app-context'
import { DasBalanceInsufficientDialogType } from '@did/das-balance-types'
import { Decimal, smartOpen, thousandSplit } from '@did/tools'
import { DasButton, Dialog } from '@did/uikit'
import { useMemo } from 'react'

export const DasBalanceInsufficientDialog: DasBalanceInsufficientDialogType = ({
  registrationFees,
  showing,
  onClose
}) => {
  const { tt, outSiteUrl, services } = useDasBalanceContext()
  const recommendedDepositAmount = useMemo(() => {
    return thousandSplit(
      new Decimal(registrationFees).add(200),
      TOKEN_DECIMAL_PLACES
    )
  }, [registrationFees])

  const commonConfig = useConfigVal({ services })

  const onManageBalance = () => {
    const link = outSiteUrl?.dasBalanceUrl
    smartOpen(link!)
    onClose?.()
  }

  return (
    <Dialog
      showing={showing}
      title={tt('Insufficient balance')}
      closeButton
      onClose={onClose}
    >
      <div>
        <div className=" text-black">
          {tt(
            'Before payment, please ensure that your .bit balance is greater than {recommendedDepositAmount} CKB. After payment, the remaining amount must not be less than {minChangeCapacity} CKB. Otherwise, the transaction can not be sent.',
            {
              recommendedDepositAmount: recommendedDepositAmount,
              minChangeCapacity: commonConfig.min_change_capacity
            }
          )}
        </div>
        <DasButton className=" my-8" block black onClick={onManageBalance}>
          {tt('Manage Balance')}
        </DasButton>
      </div>
    </Dialog>
  )
}
